import { Injectable } from '@angular/core';
import { StepModel } from '../Models/step-model';
import { StepMock } from '../DataStore/Mock/step-mock';
import { ScenarioModel } from '../Models/scenario-model';
import { ScenarioServiceService } from './scenario-service.service';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { ProjectService } from './project.service';
import { TopNavComponentComponent } from '../AppBaseComponents/top-nav-component/top-nav-component.component';

@Injectable({
  providedIn: 'root'
})
export class StepServiceService {

  constructor(private rest: RestService) { }

  public findByObjectId(id: string): StepModel {
    return StepMock.findByObjectId(id);

  }
  /* 
  public findById(id:number):StepModel{
    return StepMock.findById(id);
} */

  public findById(id: string): Observable<StepModel> {
    let projectId = localStorage.getItem("projectId");
    // return StepMock.findById(id);
    return this.rest.get('projectStep', projectId, id);
  }
  public findByIddb2(id: string): Observable<StepModel> {
    let projectId = localStorage.getItem('projectIdDb2');
    // return StepMock.findById(id);
    return this.rest.get('projectStepdb2', projectId, id);
  }
  /*   public getItems():StepModel[]{
      return StepMock.getItems();
    }
   */
  public getItems(): Observable<StepModel[]> {
    let projectId = localStorage.getItem("projectId");
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.get('projectSteps', projectId);
    }
    else {
      let projectId = localStorage.getItem('projectIdDb2');
      return this.rest.get('projectStepsdb2', projectId);
    }
  }
  public getItemsdb1(): Observable<StepModel[]> {
    let projectId = localStorage.getItem("projectId");
    return this.rest.get('projectSteps', projectId);
  }

  public getItemsdb2(): Observable<StepModel[]> {
    let projectId = localStorage.getItem('projectIdDb2');
    return this.rest.get('projectStepsdb2', projectId);
  }
  public getWebPagesByStepIddb2(stepId): Observable<StepModel[]> {
    return this.rest.get('getWebPagesByStepIddb2', stepId);
  }

  // Promotes a Web Recorder step into a regular Canvas step by clearing its "web_recorder" tag.
  public promoteToCanvasdb2(stepId: string): Observable<any> {
    const projectId = localStorage.getItem('projectIdDb2');
    return this.rest.post('clearStepSourcedb2', { projectId }, stepId);
  }

  // Targeted rename (Step.java's renameStepdb2) instead of a full-document /updatedb2 replace.
  public renameStepdb2(stepId: string, name: string): Observable<any> {
    return this.rest.post('renameStepdb2', { name }, stepId);
  }

  // Delete for a Web Recorder saved step — server only needs the id, unlike deleteModel() above.
  public deleteStepdb2(stepId: string): Observable<any> {
    const projectId = localStorage.getItem('projectIdDb2');
    const data = {
      project: { _id: projectId },
      scenariostep: { _id: stepId }
    };
    return this.rest.post('deletestepdb2', data);
  }

  // Copy for a Web Recorder saved step — reuses /step/add, which deep-clones commandSteps server-side.
  public copyStepdb2(sourceStepId: string, newName: string): Observable<any> {
    const projectId = localStorage.getItem('projectIdDb2');
    const data = {
      project: { _id: projectId },
      scenariostep: { _id: sourceStepId, name: newName, dbName: 'db2', source: 'web_recorder' }
    };
    return this.rest.put('addstep', data);
  }

  public getStepsByScenario(scenarioModel: ScenarioModel): StepModel[] {
    let step = [];

    for (let i = 0; i < scenarioModel.scenariosteps.length; i++) {
      let s = this.findByObjectId(scenarioModel.scenariosteps[i]);
      step.push(s);
    }
    return step;
  }

  public updateStep(model: StepModel) {

  }

  // public addNew(step:StepModel, scenario:ScenarioModel){
  //   StepMock.addNewStep(step);
  //   scenario.scenariosteps.push(step.id);
  //   // scenario
  // }

  public addNew(name: string, mydata: any) {
    let model = new StepModel();
    model.name = name;
    let projectId = localStorage.getItem("projectId");
    var data: any = {
      project: { _id: projectId },
      scenariostep: model
    };
    
    if (TopNavComponentComponent.currentPage.name.toUpperCase() == 'CANVAS') {
      projectId = localStorage.getItem('projectIdDb2');
      data.project._id = projectId;
      data.scenariostep.dbName = "db2";
    }
    
    return this.rest.put('addstep', data);
  }
  public edit(model) {
    let projectId = localStorage.getItem("projectId");
    if (model.commandSteps)
      model.commandSteps = model.commandSteps.map(m => { return m = m.$oid });
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    var data: any = {
      project: { _id: projectId },
      scenariostep: model
    };
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.post('updatestep', data);
    }
    else {
       return this.rest.post('updatestepdb2', data);
    }
  }
  // public editdb2(model) {
  //   let projectId = localStorage.getItem("projectId");
  //   if (model.commandSteps)
  //     model.commandSteps = model.commandSteps.map(m => { return m = m.$oid });
  //   var data = {
  //     project: { _id: projectId },
  //     scenariostep: model
  //   };
  //   return this.rest.post('updatestepdb2', data);
  // }
  public deleteModel(model) {

    let projectId = localStorage.getItem("projectId");
    if (model.commandSteps)
      model.commandSteps = model.commandSteps.map(m => { return m = m.$oid });
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    var data = {
      project: { _id: projectId },
      scenariostep: model
    };
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.post("deletestep", data);
    }
    else {
      data.project._id = localStorage.getItem('projectIdDb2');
      if (data.scenariostep.defaultPage) {
        data.scenariostep.defaultPage=data.scenariostep.defaultPage.$oid?data.scenariostep.defaultPage.$oid:data.scenariostep.defaultPage;
      }
      return this.rest.post("deletestepdb2", data);
    }

    //     StepMock.deleteModel(model);
  }
  // public deleteModeldb2(model) {
  //   let projectId = localStorage.getItem("projectId");
  //   if (model.commandSteps)
  //     model.commandSteps = model.commandSteps.map(m => { return m = m.$oid });
  //   var data = {
  //     project: { _id: projectId },
  //     scenariostep: model
  //   };
  //   return this.rest.post("deletestepdb2", data);
  //   //     StepMock.deleteModel(model);
  // }
  public saveStep(model) {

    let projectId = localStorage.getItem("projectId");
    // let projectId = localStorage.getItem('projectIdDb2');

    if (model.commandSteps)
      model.commandSteps = model.commandSteps.map(m => {
        if (m.$oid) {
          return m = m.$oid
        }
        else { return m._id; }
      }
      );
    var data = {
      project: { _id: projectId },
      scenariostep: model
    };
    return this.rest.put("addsaveStep", data);
  }

  public saveAsModel(model) {
    let projectId = localStorage.getItem("projectId");
    if(model.dbName == 'db2') {
      projectId = localStorage.getItem("projectIdDb2");
    }
    // delete model._id;
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    if (model.defaultPage) {
      model.defaultPage = model.defaultPage.$oid;
      }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
      console.log(model);
      if(model.commandSteps){
        model.commandSteps = model.commandSteps.map(m =>{return m = m.$oid});
        // model['commandSteps'] = modelIds;
      }
    let data = {
      project: { _id: projectId },
      scenariostep: model
    };

      return this.rest.put('addstep', data);
  }
}